import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './UrgencyBar';
import { HeroSection } from './HeroSection';
import { EmotionalOpening } from './EmotionalOpening';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { WhatsIncluded } from './WhatsIncluded';
import { BeforeAfter } from './BeforeAfter';
import { BonusesSection } from './BonusesSection';
import { OfferStack } from './OfferStack';
import { GuaranteeSection } from './GuaranteeSection';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { FooterSection } from './FooterSection';
import { PurchaseNotification } from './PurchaseNotification';
export function SalesPage() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (!(window as any).fbq) {
      const n: any = (window as any).fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    if ((window as any).fbq) {
      ;
      (window as any).fbq('init', '1538074310626033');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen w-full bg-white selection:bg-orange selection:text-white" data-id="element-178">
      <UrgencyBar data-id="element-179" />
      <HeroSection data-id="element-180" />
      <EmotionalOpening data-id="element-181" />
      <ProblemSection data-id="element-182" />
      <SolutionSection data-id="element-183" />
      <WhatsIncluded data-id="element-184" />
      <BeforeAfter data-id="element-185" />
      <BonusesSection data-id="element-186" />
      <OfferStack data-id="element-187" />
      <GuaranteeSection data-id="element-188" />
      <TestimonialsSection data-id="element-189" />
      <FAQSection data-id="element-190" />
      <FinalCTA data-id="element-191" />
      <FooterSection data-id="element-192" />
      <PurchaseNotification data-id="element-193" />
    </div>;
}